import classes from "./about.module.css";

const certificates = [
  {
    title: "Agentic AI",
    issuer: "Datagami (NASSCOM × IBM)",
    date: "Apr 2026",
    id: "EDU-2026-F3KPC"
  },
  {
    title: "Generative AI",
    issuer: "Datagami (NASSCOM × IBM)",
    date: "Feb 2026",
    id: "EDU-2026-JT3LF"
  },
  {
    title: "DevOps Foundations",
    issuer: "Datagami (NASSCOM × IBM)",
    date: "Jan 2026",
    id: "EDU-2026-7ALFP"
  },
  {
    title: "React.js Development",
    issuer: "Udemy",
    date: "2024"
  },
  {
    title: "JavaScript Development",
    issuer: "Udemy",
    date: "2024"
  },
  {
    title: "Smart India Hackathon 2025",
    issuer: "Government of India",
    date: "2025"
  },
  {
    title: "Published Research: Life Cycle Assessment",
    issuer: "IARI-23 Conference",
    date: "2023"
  },
];

const CertificatesInfo = () => {
  return (
    <>
      {certificates.map((item, index) => (
        <div key={index} className={`${classes.cardAbout} ${classes.certificateCard}`}>
          <div className={classes.cardAboutContainer}>
            <div className={classes.cardAboutTitle}>{item.title}</div>
            
            <p className={classes.AboutTitle}>
              {item.issuer}
            </p>
            
            {item.id && (
              <p className={classes.certificateId}>
                ID: {item.id}
              </p>
            )}
            
            <p className={classes.aboutTime}>
              <span>Issued {item.date}</span>
            </p>
          </div>
        </div>
      ))}
    </>
  );
};

export default CertificatesInfo;
